<template lang="pug">
  svg(
    width="20px"
    height="12px"
    viewBox="0 0 20 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink")

    title Combined Shape
    desc Created with Sketch.
    g(
      id="student"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      opacity="0.9")
      g(
        id="login_show_password"
        transform="translate(-339.000000, -270.000000)"
        :fill="color")
        path(
          d="M349,281 C346.238,281 344,278.761 344,276 C344,273.239 346.238,271 349,271 C351.761,271 354,273.239 354,276 C354,278.761 351.761,281 349,281 M349,270 C356.205,270 359,276 359,276 C359,276 356.236,282 349,282 C341.763,282 339,276 339,276 C339,276 341.795,270 349,270 Z M349,273 C347.343143,273 346,274.343143 346,276 C346,277.656857 347.343143,279 349,279 C350.656857,279 352,277.656857 352,276 C352,274.343143 350.656857,273 349,273 Z"
          id="Combined-Shape")
</template>

<script>
export default {
  props: {
    color: { type: String, default: '#ffffff' },
  },
}
</script>
